import {ValueObject} from '@s-ui/domain'

import {LocationEntity} from '../Entities/LocationEntity.js'

export class RegionLocationValueObject extends ValueObject {
  #region

  constructor({region}) {
    super()
    this.#region = region
  }

  static empty() {
    return new RegionLocationValueObject({region: LocationEntity.empty()})
  }

  static createFromLiterals({id, name}) {
    if (!LocationEntity.isValid({id})) return RegionLocationValueObject.empty()
    return new RegionLocationValueObject({region: LocationEntity.createFromLiterals({id, name})})
  }

  get id() {
    return this.#region.id
  }

  get name() {
    return this.#region.name
  }

  get value() {
    return this.#region.value
  }

  isEmpty() {
    return this.#region.isEmpty()
  }
}
